import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Text } from '../Text/Text';
import { FlexContainer } from '../layout/FlexContainer';
import { ExpansionTableHeaderRow } from './ExpansionTableHeaderRow';
import { ExpansionTableTitleWithSort } from './ExpansionTableTitle';
import { getRenderExpansionRowElement } from './ExpansionTableWithDates/helpers/getRenderExpansionRowElement';
import { ScrollToExpandedProvider } from './ScrollToExpandedContext';
export const ExpansionTable = ({ data, columns, defaultExpandedKey, shouldScrollToExpanded, rowHeaderTestId, sort, hasAllRowsExpanded, rowKeyExtractor, renderDetail, renderLeftRowElement, renderLeftHeaderElement, onExpand, onSort, getHasRowDetail, }) => {
    const [expandedKey, setExpandedKeyState] = useState(defaultExpandedKey ?? undefined);
    useEffect(() => {
        setExpandedKeyState(defaultExpandedKey ?? undefined);
    }, [defaultExpandedKey]);
    const setExpandedKey = (key) => {
        setExpandedKeyState(key);
        onExpand?.(key);
    };
    const mappedHeadColumns = columns.map((column) => {
        const { title: titleText, sortName, horizontalAlign } = column;
        const content = sortName && onSort && sort ? (_jsx(ExpansionTableTitleWithSort, { titleText: titleText, sortName: sortName, sort: sort, onSort: onSort })) : (_jsx(Text, { variant: 'b2', children: titleText }));
        const horizontallyAlignedContent = (_jsx(FlexContainer, { horizontalAlign: horizontalAlign, children: content }));
        return {
            key: column.key,
            grow: column.grow,
            testId: column.testId,
            content: horizontallyAlignedContent,
        };
    });
    const tableHasDetail = !!renderDetail;
    const renderExpansionRowElement = getRenderExpansionRowElement({
        rowKeyExtractor,
        rowHeaderTestId,
        renderDetail,
        renderLeftRowElement,
        getHasRowDetail,
        columns,
        hasAllRowsExpanded,
        tableHasDetail,
        expandedKey,
        setExpandedKey,
    });
    const mappedRows = data.map(renderExpansionRowElement);
    const leftHeaderElement = renderLeftHeaderElement?.();
    const maybeScrollTargetId = shouldScrollToExpanded
        ? defaultExpandedKey
        : undefined;
    return (_jsx(ScrollToExpandedProvider, { scrollTargetId: maybeScrollTargetId, children: _jsxs(FlexContainer, { direction: 'column', gap: true, children: [_jsx(ExpansionTableHeaderRow, { columns: mappedHeadColumns, hasAllRowsExpanded: hasAllRowsExpanded, tableHasDetail: tableHasDetail, leftHeaderElement: leftHeaderElement }), mappedRows] }) }));
};
